import { render, staticRenderFns } from "./statusBar.vue?vue&type=template&id=6457eafa&scoped=true"
import script from "./statusBar.vue?vue&type=script&lang=js"
export * from "./statusBar.vue?vue&type=script&lang=js"
import style0 from "./statusBar.vue?vue&type=style&index=0&id=6457eafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457eafa",
  null
  
)

export default component.exports